var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-dialogs-wrapper"},[_c('screenshot',{attrs:{"map":_vm.map}}),_c('terrain',{attrs:{"map":_vm.map}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }